import Avatar from './Avatar.vue';

export default Avatar;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/avatar/index.ts